<ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
  <div class="row">
    <div class="col-12">
      <ziro-text fieldId="name"></ziro-text>
      <ziro-radio fieldId="rangeType"></ziro-radio>
    </div>
  </div>
  <div class="row">
    <div class="col-6 d-flex flex-column">
      <label
        [ngClass]="{
          'ziro-forms-error': extensionRangesDisplayFormValidationState === validationStates.INVALID,
          'ziro-forms-warning': extensionRangesDisplayFormValidationState === validationStates.WARNING,
        }"
        data-automation="extension-ranges-label"
        class="ziro-forms-label col-form-label"
      >
        <span class="text-danger ziro-forms-asterisk">*</span>
        <span [innerText]="'tkey;admin.ms_dial_plan_exception.edit.add_number_ranges.label' | translate"></span>
      </label>
      <div class="d-flex flex-column flex-grow-1 flex-min-height-0">
        @if (displayRangeForm) {
          <ziro-extension-ranges-display-form
            data-automation="extension-ranges-display-form"
            [entity]="displayRangeFormEntity"
            [optionalValidators]="displayRangeFormOptionalValidators"
            [isRequired]="true"
            (ziroFormsUpdate$)="onRangeFormUpdate($event)"
            [isZpm]="true"
            [exceptionRangeType]="entity.rangeType"
            (isValidFromDynamicValidator)="isValidFromDynamicValidator.emit($event)"
            class="d-flex flex-column h-100"
          ></ziro-extension-ranges-display-form>
        }
      </div>
    </div>
    <div class="col-6 d-flex flex-column justify-content-between">
      <ziro-textarea fieldId="bulkRanges"></ziro-textarea>
      <ziro-button
        [dataAutomation]="'exception-group-bulk-ranges-generate-button'"
        [label]="'tkey;admin.ms_dial_plan_exception.edit.bulk_generate.button.label'"
        (clicked)="generateBulkRangesClicked()"
        [isDisabled]="validationFlags['bulkRanges'] === validationStates.INVALID"
        [tooltip]="'tkey;dialplanmanagement.admin.group.generate.button.disabled_tooltip' | translate"
        [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
        [isTooltipDisabled]="validationFlags['bulkRanges'] === validationStates.VALID"
      ></ziro-button>
    </div>
  </div>
</ziro-collapsible-section-card>
